// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"195":"e644ffaa071a04466bc1","600":"a0d01a89c3b106659d0f"}[chunkId] + ".css";
};